import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { ThemeNames } from '../../../theming/ITheme.js';
import styled__default from 'styled-components';
import React from 'react';
import _Icon from '../../../components/Icon/index.js';
import _Link from '../../../components/Link/index.js';

var _templateObject;
var StyledIconLink = styled__default(_Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 0.4rem;\n  &:first-child {\n    margin-left: 0;\n  }\n"])));
var IconLinks = function IconLinks(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, theme.name === ThemeNames.publicSite ? /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://www.facebook.com/lincolnfinancialgroup',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's Facebook Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'facebook-square-brands',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://twitter.com/lincolnfingroup',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's Twitter Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'linkedin-square-brands',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'http://www.youtube.com/lincolnfinancialgrp',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's YouTube Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'twitter-square-brands',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://www.linkedin.com/company/lincoln-financial-group?trk=tyah&trkInfo=tas%3Alincoln+financial%2Cidx%3A3-1-3',
    target: '_blank',
    rel: 'noreferrer',
    "aria-label": "Lincoln Financial's LinkedIn Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'youtube-square-brands',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://www.instagram.com/lincolnfingroup',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's Instagram Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'instagram-square-brands',
    size: 'extraLarge',
    color: 'white'
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://www.facebook.com/lincolnfinancialgroup',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's Facebook Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'facebook',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://twitter.com/lincolnfingroup',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's Twitter Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'twitter',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'http://www.youtube.com/lincolnfinancialgrp',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's YouTube Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'youtube',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://www.linkedin.com/company/lincoln-financial-group?trk=tyah&trkInfo=tas%3Alincoln+financial%2Cidx%3A3-1-3',
    target: '_blank',
    rel: 'noreferrer',
    "aria-label": "Lincoln Financial's LinkedIn Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'linkedin',
    size: 'extraLarge',
    color: 'white'
  })), /*#__PURE__*/React.createElement(StyledIconLink, {
    href: 'https://www.instagram.com/lincolnfingroup',
    target: '_blank',
    rel: 'noreferrer',
    role: 'link',
    "aria-label": "Lincoln Financial's Instagram Page"
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'instagram',
    size: 'extraLarge',
    color: 'white'
  }))));
};

export default IconLinks;
